import { LazyLoad } from 'app/utils';

export const PerformanceFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.PerformanceFormPage,
);
